import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import { toSearchString } from 'utils/url';
import { FilterBrandsModal } from 'components';
import * as gtm from '../../search-gtm';

class FilterBrands extends Component {
    static propTypes = {
        filterBrands: PropTypes.shape({
            name: PropTypes.string,
            options: PropTypes.array,
            parameter: PropTypes.string,
            selectedValues: PropTypes.array,
            type: PropTypes.string
        }).isRequired,
        handleBrandChange: PropTypes.func,
        location: PropTypes.shape({
            color: PropTypes.string
        }),
        queryParams: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            modalOpen: 'closed'
        };
    }

    handleModal = () => {
        if (this.state.modalOpen === 'open') {
            this.setState({
                modalOpen: 'closed'
            });
        } else {
            this.setState({
                modalOpen: 'open'
            });
        }
    };

    getLinkValue = brand => {
        const { queryParams, location } = this.props;
        if (brand && queryParams && location) {
            const query = {
                ...queryParams,
                brandTags: brand.value
            };
            return { ...location, search: toSearchString(query) };
        }
    };

    renderLink = (brand, index, selected) => (
        <Link
            to={this.getLinkValue(brand) || {}}
            className={`btn btn-sm m-1 ${
                selected ? 'btn-dark' : 'btn-outline-dark'
            } ${index > 5 && !selected ? 'd-none' : 'd-inline-block'}`}
            onClick={e => {
                // Give more responsive feel not waiting for response
                if (selected) {
                    e.currentTarget.classList.add('btn-outline-dark');
                    e.currentTarget.classList.remove('btn-dark');
                } else {
                    e.currentTarget.classList.remove('btn-outline-dark');
                    e.currentTarget.classList.add('btn-dark');
                }
            }}
            key={index}>
            {brand.name}
            <span className="d-inline-block ml-1">({brand.count})</span>
        </Link>
    );

    renderButton = (brand, index, selected, parameter, handleBrandChange) => (
        <button
            type="button"
            className={`btn btn-sm m-1 ${
                selected ? 'btn-dark' : 'btn-outline-dark'
            } ${index > 5 && !selected ? 'd-none' : 'd-inline-block'}`}
            onClick={e => {
                handleBrandChange(parameter, brand.value);
                // Give more responsive feel not waiting for response
                if (selected) {
                    e.currentTarget.classList.add('btn-outline-dark');
                    e.currentTarget.classList.remove('btn-dark');
                } else {
                    e.currentTarget.classList.remove('btn-outline-dark');
                    e.currentTarget.classList.add('btn-dark');
                }
            }}
            key={index}>
            {brand.name}
            <span className="d-inline-block ml-1">({brand.count})</span>
        </button>
    );

    // Render brand tags as links or buttons depending on selection to prevent crawl trap.
    renderBrandsListTags = brands => {
        const { handleBrandChange, filterBrands = {} } = this.props;
        const { parameter, selectedValues } = filterBrands;
        return brands.map((brand, index) => {
            const selected = selectedValues.includes(brand.value);
            if (selectedValues.length > 0) {
                return this.renderButton(
                    brand,
                    index,
                    selected,
                    parameter,
                    handleBrandChange
                );
            } else {
                return this.renderLink(brand, index, selected);
            }
        });
    };

    render() {
        const { filterBrands, handleBrandChange } = this.props;
        const { modalOpen } = this.state;
        const { options } = filterBrands;
        if (!options) {
            return null;
        }
        return (
            <div className="pb-2">
                {this.renderBrandsListTags(options)}
                {options.length > 6 ? (
                    <button
                        className="btn btn-sm btn-primary d-block m-1"
                        onClick={() => {
                            gtm.trackFilter('brandTags', 'Button - View all');
                            this.setState({
                                modalOpen: 'open'
                            });
                        }}>
                        Visa alla ({options.length} st)
                    </button>
                ) : null}
                {modalOpen === 'open' ? (
                    <FilterBrandsModal
                        filterBrands={filterBrands}
                        handleBrandChange={handleBrandChange}
                        onClose={this.handleModal}
                    />
                ) : null}
            </div>
        );
    }
}

export default withRouter(FilterBrands);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-results/filters/brands/filter-brands.jsx